var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"num-card",style:({'background-color': _vm.bgcolor })},[_c('div',{staticClass:"num-card__total"},[_c('span',{style:({'color':_vm.color})},[_vm._v(_vm._s(_vm.total === null ? '-' : _vm.total))]),_vm._v(_vm._s(_vm.danwei)+"\n  ")]),_c('div',{staticClass:"num-card__name"},[_c('span',[_vm._v(_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }